import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../../shared/config';
import { map } from 'rxjs/operators';
import { ChangePassword } from '../models/change-password';
import { ChangePasswordResponse } from '../models/change-password-response';
import { ChangeUserAccount } from '../models/change-user-account';
import { UserAccount } from '../../core/models/account';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsService extends BaseHttpService {


  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  changePassword(data: ChangePassword): Observable<ChangePasswordResponse> {

    return this._http.post(config.generateApiUrl('Auth/changepassword'), data).pipe(
      map((resp) => resp['data'])
    );
  }

  changeUserAccount(data: ChangeUserAccount): Observable<ChangePasswordResponse> {
    // Changing the login requires the user-scoped endpoint; the plain one only accepts an email.
    if (data?.userAccountId) {
      return this._http.put(config.generateApiUrl(`userAccount/${data.userAccountId}`, null, null, '2.2'), data).pipe(
        map((resp) => resp['data'])
      );
    }

    return this._http.put(config.generateApiUrl('UserAccount', null, null, '2.2'), data).pipe(
      map((resp) => resp['data'])
    );
  }

  getAccount(): Observable<UserAccount> {
    return this.get(config.generateApiUrl('UserAccount', null, null, '2.2')).pipe(
      map((resp) => resp['data'] as UserAccount)
    );
  }

  deleteAccount(): Observable<any> {
    return this._http.delete(config.generateApiUrl('UserAccount', null, null, '2.2'));
  }
}
